import {
  GET_SERVICES,
  CREATE_SERVICES,
  DELETE_SERVICES,
  UPDATE_SERVICES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

// common success
export const ServicesApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const ServicesApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Services = () => ({
  type: GET_SERVICES,
});

export const CreateServices = (data) => ({
  type: CREATE_SERVICES,
  payload: { data },
});

export const UpdateServices = (id, data) => ({
  type: UPDATE_SERVICES,
  payload: { id, data },
});

export const DeleteServices = (id) => ({
  type: DELETE_SERVICES,
  payload: { id },
});
